import React from "react";
import IField from "../../../../interfaces/field";
import TplGroup from "../tpl-group";

import { Select as SelectElement } from "./styles";

type IProps = any & IField;

const Select = ({
  title,
  required = false,
  name,
  prefixName = "",
  onChange,
  ...el
}: IProps): JSX.Element | null => {
  const handleChange = (event: { target: { value: string } }): void => {
    let { value } = event.target;
    if (onChange) {
      onChange(value, el.setFieldValue);
    }
    if (el.validations?.includes("email")) value = event.target.value.replace(/\s/g, "");

    if (el.setFieldValue) {
      el.setFieldValue(`${prefixName}${name}`, value);
    }
  };

  return (
    <TplGroup
      name={`${prefixName}${name}`}
      title={title}
      prefixName={prefixName}
      required={required}
      {...el}
    >
      <SelectElement
        {...el}
        name={`${prefixName}${name}`}
        required={required}
        value={el.values[name]}
        onChange={(event: any) => handleChange(event)}
      >
        <option value="">Selecione uma opção</option>
        {el.options.map((option: { value: any; label: string }) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </SelectElement>
    </TplGroup>
  );
};

export default Select;
